import React, { useEffect } from 'react';
import './CustomAlert.css'; // Custom CSS for styling the alert

const CustomAlert = ({ message, type, onClose }) => {
  const alertClass = type === 'error' ? 'custom-alert-error' : 'custom-alert-success';

  // Automatically close the alert after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    // Cleanup the timer if the component is unmounted before the timeout
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`custom-alert ${alertClass}`}>
      <span>{message}</span>
      <button onClick={onClose} className="custom-alert-close-btn">&times;</button>
    </div>
  );
};

export default CustomAlert;
